import shallowEqual from 'fbjs/lib/shallowEqual';

export default shallowEqual;


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/lib/shallowEqual.js
// module id = 2479
// module chunks = 1